import { Autocomplete, Box, FormControl, Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import ExpenseCard from '../ExpenseCard.js/ExpenseCard';
import OpaqueLoading from '../../../components/common/opaqueLoading/opaqueLoading';

const Container = styled.div`
  width: 100%;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 20px 25px;
  width: 100%;
  height: 100%;
  align-items: stretch;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const ClaimExpense = () => {
  const [expenses, setExpenses] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState();
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      getExpenseList();
    } else {
      window.location.reload();
    }
  }, []);

  const getExpenseList = async () => {
    try {
      const result = await window.Platform.database.getExpenseList({
        isDraft: false,
      });
      setExpenses(result.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleMonthChange = async (value) => {
    setLoading(true);
    setSelectedMonth(value ?? '');
    try {
      const result = await window.Platform.database.getExpenseList({
        isDraft: false,
        searchField: value ?? '',
      });
      setExpenses(result.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      window.NotificationUtils.showError(error.message);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        height: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='expense' />
        <Box p={4}>
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <FormControl style={{ width: '150px' }} size='small'>
              <Autocomplete
                size='small'
                value={selectedMonth || null}
                onChange={(event, newValue) => handleMonthChange(newValue)}
                options={months}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Month'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue.toLowerCase())
                  );
                }}
              />
            </FormControl>
          </Box>
        </Box>

        {expenses.length > 0 ? (
          <Grid container spacing={2} padding={2} pt={0}>
            <GridContainer>
              {expenses.map((expense) => {
                return (
                  <ExpenseCard
                    key={expense.event_heroku_id__c}
                    expense={expense}
                    type='claim'
                  />
                );
              })}
            </GridContainer>
          </Grid>
        ) : (
          <NotDiv>No Data Found</NotDiv>
        )}
      </Container>
    </div>
  );
};

export default ClaimExpense;
